<template>
    <img
        alt="99math Logo"
        class="img-wrapper logo"
        :class="{ 'logo--not-clickable': !clickable }"
        :src="logoImage"
        @click="onClick"
    />
</template>
<script>
import { QuitGame } from '@/core/mixins/QuitGame';
import { supportWebPImage } from '@/core/helpers/utils';
import {
    isParent,
    isTeacher,
    isStudent,
} from '@/flows/Authentication/helpers/AuthHelpers';
import { mapGetters } from 'vuex';
import logoWebp from '@/assets/logo.webp';
import logoAltWebp from '@/assets/logo-alt.webp';
import logoPng from '@/assets/logo.png';
import logoAltPng from '@/assets/logo-alt.png';

export default {
    mixins: [QuitGame],
    props: {
        confirmBeforeQuit: {
            type: Boolean,
            required: false,
            default: true,
        },
        routeToRedirectTo: {
            type: String,
            required: false,
        },
        altLogo: {
            type: Boolean,
            required: false,
            default: false,
        },
        clickable: {
            type: Boolean,
            required: false,
            default: true,
        },
        emitOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: ['click'],
    data() {
        return {
            logoImage: supportWebPImage()
                ? this.altLogo
                    ? logoAltWebp
                    : logoWebp
                : this.altLogo
                    ? logoAltPng
                    : logoPng,
        };
    },
    computed: {
        ...mapGetters(['user']),
        isStudent() {
            return isStudent(this.user);
        },
        isTeacher() {
            return isTeacher(this.user);
        },
        isParent() {
            return isParent(this.user);
        },
        setRouteToRedirectTo() {
            return (
                this.routeToRedirectTo ||
                (this.isStudent || this.isParent
                    ? 'home-game.v10.main-page'
                    : 'host')
            );
        },
    },
    methods: {
        onClick() {
            if (!this.clickable) return;

            if (this.emitOnly) {
                this.$emit('click');
                return;
            }

            console.debug('LOGO QUIT TO:', this.setRouteToRedirectTo);
            this.quitGame(
                this.confirmBeforeQuit,
                'logo',
                this.setRouteToRedirectTo,
            );
        },
    },
};
</script>
